// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2fCGE","signatureBlock":"Footer_signatureBlock__3Cqbj","signature":"Footer_signature__3xwC-"};